<template>
    <div class="signup-select-role">
        <div class="container">
            <RoleCard 
                role="R2 Player" 
                title="Play with every Solution" 
                :desc="localize('임상을 쉽게, 즐겁게, 스마트하게!<br/>R2 Playground 솔루션을<br/>지금 만나보세요.')"
            />
            <RoleCard 
                role="R2 Center" 
                title="Support every R2player" 
                :desc="localize('최첨단 장비와 전문 노하우!<br/>전 세계 R2player들의 든든한 파트너가 되어 주세요.')"
            />
            <RoleCard 
                role="R2 Planner" 
                title="Behind every great case!" 
                :desc="localize('R2 진단부터 디자인까지!<br/>R2player들의 든든한 플래너가 되세요.')"    
            />
            <RoleCard 
                role="R2 Center Crew" 
                :title="localize('R2 Center 직원 전용!')" 
                :desc="localize('Crew로서 전문성과 경력을 함께<br/>키워가세요.')"
                :disabled="true"
            />
        </div>
    </div>
</template>

<script>
import { useRoute } from "vue-router";
import RoleCard from "./RoleCard.vue"
import { localize } from "@/utils";
import { useLocalizationStore } from "@/store";
import { onMounted } from "vue";
export default {
    name: "SelectRole",
    components: {
        RoleCard,
    },
    setup () {
        const route = useRoute();
        const localizationStore = useLocalizationStore();

        onMounted(async() => {
            const lang = route.query.lang
            if(lang === "ko") {
                await localizationStore.setLanguage("ko-KR")
            }
            if(lang === "en") {
                await localizationStore.setLanguage("en-US")
            }
        })
        return {
            localize
        }
    }
}
</script>

<style lang="scss" scoped>
.signup-select-role {
    font-family: 'Pretendard';
    .container {
        all: unset;
        max-width: none;
        display: flex;
        align-items: center;
        gap: 50px;
        padding: 0 65px;
        justify-content: center;
    }
}
</style>